(function() {

  'use strict';

  var STORAGE_KEY = 'carnet_gaucho_entries';

  var form = document.getElementById('carnetGauchoForm');

  if (!form) return;

  var entriesContainer = document.getElementById('cgEntries');

  var emptyState = document.getElementById('cgEmpty');

  var countEl = document.getElementById('cgCount');

  var exportBtn = document.getElementById('cgExportBtn');

  var toast = document.getElementById('cgToast');

  var cfg = document.getElementById('cgConfig');

  var T = {

    toastSave: cfg.getAttribute('data-toast-save') || 'Dégustation enregistrée !',

    toastDelete: cfg.getAttribute('data-toast-delete') || 'Dégustation supprimée',

    toastExport: cfg.getAttribute('data-toast-export') || 'Fichier téléchargé !',

    confirmDelete: cfg.getAttribute('data-confirm-delete') || 'Supprimer cette dégustation ?',

    countSingular: cfg.getAttribute('data-count-singular') || 'dégustation enregistrée',

    countPlural: cfg.getAttribute('data-count-plural') || 'dégustations enregistrées',

    intensite: ['', cfg.getAttribute('data-intensite-1') || 'Douce', cfg.getAttribute('data-intensite-2') || 'Légère', cfg.getAttribute('data-intensite-3') || 'Moyenne', cfg.getAttribute('data-intensite-4') || 'Forte', cfg.getAttribute('data-intensite-5') || 'Très forte'],

    labelArome: cfg.getAttribute('data-label-arome') || 'Arôme :',

    labelSaveur: cfg.getAttribute('data-label-saveur') || 'Saveur :',

    labelIntensite: cfg.getAttribute('data-label-intensite') || 'Intensité :',

    labelRecommandee: cfg.getAttribute('data-label-recommandee') || 'Recommandée',

    labelNonRecommandee: cfg.getAttribute('data-label-non-recommandee') || 'Non recommandée',

    btnSupprimer: cfg.getAttribute('data-btn-supprimer') || 'Supprimer',

    exportTitle: cfg.getAttribute('data-export-title') || 'MON CARNET GAUCHO — Journal de Dégustation',

    exportDate: cfg.getAttribute('data-export-date') || 'Exporté le',

    exportLabelDate: cfg.getAttribute('data-export-label-date') || 'Date :',

    exportLabelArome: cfg.getAttribute('data-export-label-arome') || 'Arôme :',

    exportLabelSaveur: cfg.getAttribute('data-export-label-saveur') || 'Saveur :',

    exportLabelIntensite: cfg.getAttribute('data-export-label-intensite') || 'Intensité :',

    exportLabelSensation: cfg.getAttribute('data-export-label-sensation') || 'Sensation :',

    exportLabelRecommandee: cfg.getAttribute('data-export-label-recommandee') || 'Recommandée :',

    exportOui: cfg.getAttribute('data-export-oui') || 'Oui',

    exportNon: cfg.getAttribute('data-export-non') || 'Non',

    shareTitle: cfg.getAttribute('data-share-title') || 'Mon Carnet Gaucho'

  };

  var editingId = null, storageError = false;
  var ratings = { aroma: 0, sabor: 0 };


  var submitLabel=form.querySelector('[type=submit]').textContent;
  function makeButton(label, action){var b=document.createElement('button');b.type='button';b.className='carnet-gaucho__btn carnet-gaucho__btn--secondary';b.textContent=label;b.addEventListener('click',action);return b;}
  function saveEntries(entries){try{if(storageError)throw Error();localStorage.setItem(STORAGE_KEY,JSON.stringify(entries));return true;}catch(e){showToast('Enregistrement impossible. Vos notes ne sont pas sauvegardées : vérifiez le stockage de votre navigateur.');return false;}}
  var cancelEdit=makeButton('Annuler la modification',function(){editingId=null;form.reset();ratings.aroma=ratings.sabor=0;document.querySelectorAll('.carnet-gaucho__stars').forEach(function(g){updateStarsUI(g,0);});initDateField();form.querySelector('[type=submit]').textContent=submitLabel;cancelEdit.hidden=true;});cancelEdit.hidden=true;form.appendChild(cancelEdit);
  exportBtn.parentNode.appendChild(makeButton('Sauvegarder une copie',function(){
    var entries=getEntries();if(storageError){showToast('Impossible de lire les notes.');return;}
    var blob=new Blob([JSON.stringify({format:'el-gaucho-carnet',version:1,entries:entries},null,2)],{type:'application/json'});
    var url=URL.createObjectURL(blob),link=document.createElement('a');link.href=url;link.download='carnet-gaucho-'+new Date().toISOString().slice(0,10)+'.json';document.body.appendChild(link);link.click();link.remove();setTimeout(function(){URL.revokeObjectURL(url);},10000);
  }));
  var input=document.createElement('input');input.type='file';input.accept='.json,application/json';input.hidden=true;exportBtn.parentNode.appendChild(input);
  exportBtn.parentNode.appendChild(makeButton('Importer une copie',function(){input.click();}));
  var info=document.createElement('p');info.textContent='Vos notes restent dans ce navigateur. Téléchargez une copie pour les conserver et importez-la sur un autre appareil. Aucune synchronisation automatique. L’import ajoute les notes sans effacer les notes existantes.';exportBtn.parentNode.appendChild(info);
  function validEntry(e){return e && Number.isSafeInteger(e.id) && e.id>0 && ['yerba','date','aromaDesc','saborDesc','sensation'].every(function(k){return typeof e[k]==='string' && e[k].length<=10000;}) && e.yerba.trim() && /^\d{4}-\d{2}-\d{2}$/.test(e.date) && ['aroma','sabor'].every(function(k){return Number.isInteger(e[k])&&e[k]>=0&&e[k]<=5;}) && Number.isInteger(e.intensite)&&e.intensite>=1&&e.intensite<=5 && ['oui','non'].includes(e.recommande);}
  function fingerprint(e){return JSON.stringify([e.yerba,e.date,e.aroma,e.aromaDesc,e.sabor,e.saborDesc,e.intensite,e.sensation,e.recommande]);}
  input.addEventListener('change',async function(){try{
    var f=input.files[0];if(!f)return;if(f.size>2000000)throw Error();
    var data=JSON.parse(await f.text());if(data.format!=='el-gaucho-carnet'||data.version!==1||!Array.isArray(data.entries)||data.entries.length>5000||!data.entries.every(validEntry))throw Error();
    var entries=getEntries();if(storageError)throw Error();var seen=new Set(entries.map(fingerprint)),ids=new Set(entries.map(function(e){return e.id;})),added=0;
    data.entries.forEach(function(e){var key=fingerprint(e);if(seen.has(key))return;seen.add(key);while(ids.has(e.id))e.id++;ids.add(e.id);entries.push(e);added++;});
    if(saveEntries(entries)){renderEntries();showToast(added+' dégustation(s) importée(s).');}
  }catch(e){showToast('Copie invalide ou illisible. Aucune note existante n’a été modifiée.');}finally{input.value='';}});

  initDateField();

  initStars();

  renderEntries();

  form.addEventListener('submit', handleSubmit);

  exportBtn.addEventListener('click', handleExport);

  function initDateField() {

    var dateInput = document.getElementById('cg-date');

    dateInput.value = new Date(Date.now() - new Date().getTimezoneOffset()*60000).toISOString().split('T')[0];

  }

  function initStars() {

    var starGroups = document.querySelectorAll('.carnet-gaucho__stars');

    for (var g = 0; g < starGroups.length; g++) {

      (function(group) {

        var field = group.getAttribute('data-field');

        var stars = group.querySelectorAll('.carnet-gaucho__star');

        for (var s = 0; s < stars.length; s++) {

          (function(star, idx) {

            star.addEventListener('click', function() {

              ratings[field] = idx + 1;

              updateStarsUI(group, idx + 1);

            });

          })(stars[s], s);

        }

      })(starGroups[g]);

    }

  }

  function updateStarsUI(group, value) {

    var stars = group.querySelectorAll('.carnet-gaucho__star');

    for (var i = 0; i < stars.length; i++) {

      if (i < value) { stars[i].classList.add('carnet-gaucho__star--active'); }

      else { stars[i].classList.remove('carnet-gaucho__star--active'); }

    }

  }

  function handleSubmit(e) {

    e.preventDefault();

    var entry = {

      id: editingId || Date.now(),

      yerba: document.getElementById('cg-yerba').value.trim(),

      date: document.getElementById('cg-date').value,

      aroma: ratings.aroma,

      aromaDesc: document.getElementById('cg-aroma-desc').value.trim(),

      sabor: ratings.sabor,

      saborDesc: document.getElementById('cg-sabor-desc').value.trim(),

      intensite: parseInt(document.getElementById('cg-intensite').value, 10),

      sensation: document.getElementById('cg-sensation').value.trim(),

      recommande: document.querySelector('input[name="cg-recommande"]:checked').value

    };

    var entries = getEntries();

    if (editingId) entries = entries.filter(function(x){return x.id !== editingId;});
    entries.unshift(entry);

    if (!saveEntries(entries)) return;

    editingId = null; cancelEdit.hidden = true;
    form.querySelector('[type=submit]').textContent = submitLabel;
    form.reset();

    ratings.aroma = 0;

    ratings.sabor = 0;

    var groups = document.querySelectorAll('.carnet-gaucho__stars');

    for (var i = 0; i < groups.length; i++) { updateStarsUI(groups[i], 0); }

    document.getElementById('cg-intensite').value = 3;

    initDateField();

    renderEntries();

    showToast(T.toastSave);

  }

  function renderEntries() {

    var entries = getEntries();

    entriesContainer.innerHTML = '';

    if (entries.length === 0) {

      emptyState.style.display = 'block';

      exportBtn.style.display = 'none';

      countEl.textContent = '';

      return;

    }

    emptyState.style.display = 'none';

    exportBtn.style.display = 'inline-flex';

    countEl.textContent = entries.length + ' ' + (entries.length > 1 ? T.countPlural : T.countSingular);

    for (var i = 0; i < entries.length; i++) { entriesContainer.appendChild(createEntryCard(entries[i])); }

  }

  function createEntryCard(entry) {

    var card = document.createElement('div');

    card.className = 'carnet-gaucho__entry';

    var dateFormatted = formatDate(entry.date);

    var aromaStars = renderStarsHTML(entry.aroma);

    var saborStars = renderStarsHTML(entry.sabor);

    var intensiteLabel = T.intensite[entry.intensite] || '';

    var html = '';

    html += '<div class="carnet-gaucho__entry-top">';

    html += '<h3 class="carnet-gaucho__entry-yerba">' + escapeHTML(entry.yerba) + '</h3>';

    html += '<span class="carnet-gaucho__entry-date">' + dateFormatted + '</span>';

    html += '</div>';

    html += '<div class="carnet-gaucho__entry-scores">';

    html += '<div class="carnet-gaucho__entry-score"><span>' + escapeHTML(T.labelArome) + '</span> ' + aromaStars;

    if (entry.aromaDesc) html += ' <span class="carnet-gaucho__entry-desc">\u2014 ' + escapeHTML(entry.aromaDesc) + '</span>';

    html += '</div>';

    html += '<div class="carnet-gaucho__entry-score"><span>' + escapeHTML(T.labelSaveur) + '</span> ' + saborStars;

    if (entry.saborDesc) html += ' <span class="carnet-gaucho__entry-desc">\u2014 ' + escapeHTML(entry.saborDesc) + '</span>';

    html += '</div>';

    html += '<div class="carnet-gaucho__entry-score"><span>' + escapeHTML(T.labelIntensite) + '</span> ' + entry.intensite + '/5 (' + intensiteLabel + ')</div>';

    html += '</div>';

    if (entry.sensation) { html += '<div class="carnet-gaucho__entry-sensation">' + escapeHTML(entry.sensation) + '</div>'; }

    html += '<div class="carnet-gaucho__entry-footer">';

    html += '<span class="carnet-gaucho__entry-recommend carnet-gaucho__entry-recommend--' + entry.recommande + '">';

    html += entry.recommande === 'oui' ? '&#10003; ' + escapeHTML(T.labelRecommandee) : '&#10007; ' + escapeHTML(T.labelNonRecommandee);

    html += '</span>';

    html += '<button type="button" class="carnet-gaucho__btn carnet-gaucho__btn--danger" data-delete="' + entry.id + '">' + escapeHTML(T.btnSupprimer) + '</button>';

    html += '</div>';

    card.innerHTML = html;

    card.querySelector('[data-delete]').addEventListener('click', function() {

      if (confirm(T.confirmDelete)) { deleteEntry(entry.id); }

    });

    var edit = makeButton('Modifier', function(){
      editingId=entry.id;
      ['yerba','date','aroma-desc','sabor-desc','intensite','sensation'].forEach(function(k){document.getElementById('cg-'+k).value=entry[{'aroma-desc':'aromaDesc','sabor-desc':'saborDesc'}[k] || k];});
      ratings.aroma=entry.aroma; ratings.sabor=entry.sabor;
      document.querySelectorAll('.carnet-gaucho__stars').forEach(function(g){updateStarsUI(g, ratings[g.getAttribute('data-field')]);});
      form.querySelector('[value='+entry.recommande+']').checked=true;
      form.querySelector('[type=submit]').textContent='Enregistrer les modifications'; cancelEdit.hidden=false;
      document.getElementById('cg-yerba').focus();
    });
    card.appendChild(edit);
    return card;

  }

  function deleteEntry(id) {

    var entries = getEntries().filter(function(e) { return e.id !== id; });

    if (!saveEntries(entries)) return;

    renderEntries();

    showToast(T.toastDelete);

  }

  function handleExport() {

    var entries = getEntries();

    if (entries.length === 0) return;

    var lines = [];

    lines.push(T.exportTitle);

    lines.push(T.exportDate + ' ' + new Date().toLocaleDateString('fr-FR'));

    lines.push('='.repeat(50));

    lines.push('');

    for (var i = 0; i < entries.length; i++) {

      var e = entries[i];

      lines.push((i + 1) + '. ' + e.yerba);

      lines.push('   ' + T.exportLabelDate + ' ' + formatDate(e.date));

      lines.push('   ' + T.exportLabelArome + ' ' + e.aroma + '/5' + (e.aromaDesc ? ' \u2014 ' + e.aromaDesc : ''));

      lines.push('   ' + T.exportLabelSaveur + ' ' + e.sabor + '/5' + (e.saborDesc ? ' \u2014 ' + e.saborDesc : ''));

      lines.push('   ' + T.exportLabelIntensite + ' ' + e.intensite + '/5');

      if (e.sensation) lines.push('   ' + T.exportLabelSensation + ' ' + e.sensation);

      lines.push('   ' + T.exportLabelRecommandee + ' ' + (e.recommande === 'oui' ? T.exportOui : T.exportNon));

      lines.push('');

    }

    var text = lines.join('\n');

    if (navigator.share) {

      navigator.share({ title: T.shareTitle, text: text }).catch(function() { downloadText(text); });

    } else { downloadText(text); }

  }

  function downloadText(text) {

    var blob = new Blob([text], { type: 'text/plain;charset=utf-8' });

    var url = URL.createObjectURL(blob);

    var a = document.createElement('a');

    a.href = url;

    a.download = 'carnet-gaucho.txt';

    document.body.appendChild(a);

    a.click();

    document.body.removeChild(a);

    URL.revokeObjectURL(url);

    showToast(T.toastExport);

  }

  function getEntries() {

    try { var data=JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; if(!Array.isArray(data)) throw Error(); storageError=false; return data; }

    catch(e) { storageError=true; return []; }

  }

  function renderStarsHTML(value) {

    var filled = '', empty = '';

    for (var i = 0; i < 5; i++) {

      if (i < value) { filled += '&#9733;'; } else { empty += '&#9733;'; }

    }

    var html = '<span class="carnet-gaucho__entry-stars">' + filled + '</span>';

    if (empty) html += '<span class="carnet-gaucho__entry-stars--empty">' + empty + '</span>';

    return html;

  }

  function formatDate(dateStr) {

    if (!dateStr) return '';

    var parts = dateStr.split('-');

    return parts[2] + '/' + parts[1] + '/' + parts[0];

  }

  function escapeHTML(str) {

    var div = document.createElement('div');

    div.textContent = str;

    return div.innerHTML;

  }

  function showToast(msg) {

    toast.textContent = msg;

    toast.classList.add('carnet-gaucho__toast--visible');

    setTimeout(function() { toast.classList.remove('carnet-gaucho__toast--visible'); }, 2500);

  }

})();

